import * as React from 'react';
import Box from '@mui/material/Box';
import AppNavbar from '../components/navigation/AppNavbar';
import Header from '../components/header/Header';
import MainGrid from '../components/dashboard/MainGrid';
import SideMenu from '../components/navigation/SideMenu';

export default function Dashboard() {
    return (
        <Box sx={{ display: 'flex' }}>
            <SideMenu />
            <AppNavbar />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    width: '100%',
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'auto',
                    bgcolor: 'background.default',
                }}
            >
                <Header />
                <Box
                    sx={{
                        flex: 1,
                        width: '100%',
                        maxWidth: '100%',
                        px: { xs: 2, sm: 3 },
                        py: { xs: 2, sm: 3 },
                        pb: 5,
                        mt: { xs: 8, md: 0 },
                    }}
                >
                    <MainGrid />
                </Box>
            </Box>
        </Box>
    );
}
